import { createActions } from 'redux-actions';

export const actions = createActions({
  FLASH_MESSAGES: {
    NOTIFY: (payload) => payload,
    DISMISS: (payload) => payload,
  },
}).flashMessages;
